import { jsx as v } from "react/jsx-runtime";
import { produce as E, current as l } from "immer";
import { isEmpty as n } from "lodash-es";
import I, { useReducer as b, useMemo as S, useContext as T } from "react";
import { S as u } from "../../../errors-YTprc4A2.mjs";
const m = I.createContext({}), p = 500, y = (r) => ({
  error: void 0,
  currentStepId: "",
  steps: {},
  formValues: r.initialValues,
  formErrors: r.initialErrors,
  formTouched: r.initialTouched,
  version: 1,
  delayedLoadingMs: p,
  mode: "Normal",
  status: "idle",
  isNavigationEnabled: !0,
  isUseButtonDisabled: !1
}), g = (r, s) => E(r, (e) => {
  const o = (t) => {
    const { values: i, errors: d, touched: a } = t;
    i && (typeof i == "object" ? e.formValues = {
      ...e.formValues,
      ...i
    } : e.formValues = i), d && (typeof d == "object" ? e.formErrors = {
      ...e.formErrors,
      ...d
    } : e.formErrors = d), a && (typeof a == "object" ? e.formTouched = {
      ...e.formTouched,
      ...a
    } : e.formTouched = a), e.version = e.version + 1;
  };
  switch (s.type) {
    case "API_REQUEST":
      e.error = s.error, e.status = s.status;
      break;
    case "UPDATE_STEP": {
      if (n(l(e.steps[s.stepId])))
        throw new u(
          `Given step id ${s.stepId} was not found in the wizard steps collection`
        );
      let t = !1;
      s.title && (e.steps[s.stepId].title = s.title, t = !0), s.navigation && (e.steps[s.stepId].navigation = s.navigation, t = !0), s.stepName && (e.steps[s.stepId].stepName = s.stepName, t = !0), s.validation && (e.steps[s.stepId].validation = s.validation, t = !0), t && (e.version = e.version + 1);
      break;
    }
    case "STEP_TRANSITION":
      e.error = void 0, e.status = s.loading ? "pending" : "idle";
      break;
    case "SET_FORM_PROPS":
      o({
        values: s.values,
        errors: s.errors,
        touched: s.touched
      });
      break;
    case "INIT_VALUES":
      o({ values: s.values });
      break;
    case "GOTO_STEP":
      if (n(l(e.steps[s.stepId])))
        throw new u(
          `Given step id ${s.stepId} was not found in the wizard steps collection`
        );
      o({ values: s.values }), e.currentStepId = s.stepId, e.status = "pending", e.delayedLoadingMs = s.delayedLoadingMs ?? p;
      break;
    case "CHANGE_MODE":
      if (n(l(e.steps[s.stepId])))
        throw new u(
          `Given step id ${s.stepId} was not found in the wizard steps collection`
        );
      e.mode = s.mode, e.currentStepId = s.stepId, e.delayedLoadingMs = s.delayedLoadingMs ?? p, o({ values: s.values });
      break;
    case "CHANGE_NAVIGATION_STATUS":
      e.isNavigationEnabled = s.isNavigationEnabled;
      break;
    case "CHANGE_BUTTON_STATUS":
      e.isUseButtonDisabled = s.isUseButtonDisabled;
      break;
  }
}), _ = ({
  children: r,
  ...s
}) => {
  const [e, o] = b(g, s), t = S(
    () => ({
      dispatch: o,
      steps: e.steps,
      appStates: s.appStates,
      error: e.error,
      currentStepId: e.currentStepId,
      formValues: e.formValues,
      formErrors: e.formErrors,
      formTouched: e.formTouched,
      mode: e.mode,
      version: e.version,
      delayedLoadingMs: e.delayedLoadingMs,
      isIdle: e.status === "idle" || e.status === "resolved",
      isPending: e.status === "pending",
      isRejected: e.status === "rejected",
      isNavigationEnabled: e.isNavigationEnabled,
      isUseButtonDisabled: e.isUseButtonDisabled
    }),
    [
      s.appStates,
      e.currentStepId,
      e.delayedLoadingMs,
      e.error,
      e.mode,
      e.status,
      e.steps,
      e.formValues,
      e.formErrors,
      e.formTouched,
      e.version,
      e.isNavigationEnabled,
      e.isUseButtonDisabled
    ]
  );
  return /* @__PURE__ */ v(m.Provider, { value: t, children: r });
};
function U() {
  const r = T(m);
  if (!r)
    throw new u("WizardContext must be used with WizardProvider!");
  return r;
}
export {
  _ as WizardProvider,
  y as initialState,
  U as useWizardContext
};
